import { LOCALES, KEYS } from "../constants";

const thTHTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_THAI_TH] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"บทบาทของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"ผู้ผสานรวม",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"ผู้ให้บริการ",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"ระดับของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"ความชำนาญเฉพาะทางของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"ชื่อบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"ตำแหน่งที่ตั้ง",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"ประเทศ",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"คำสำคัญชื่อบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"คำสำคัญชื่อบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"การเรียงลำดับ",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"ความเชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"ความเชี่ยวชาญของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"ระดับผู้ให้บริการและ Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"ผู้ให้บริการระดับ Gold",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"ผู้ให้บริการชั้นนำ",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"เลือกผู้ให้บริการ",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"รับคำแนะนำ",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"ขอใบเสนอราคา",
    [KEYS.L18N_KEY_LABEL_OPEN ]:" เปิด",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"ขยาย",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"ยุบ",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"เลือกประเทศ/ภูมิภาค",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"เลือกบทบาท",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"เลือกความเชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"เลือก Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"เลือกความเชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"เลือกระดับ",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"ประเทศ/ภูมิภาคของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"ระดับผู้ผสานรวม",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"ระดับผู้ให้บริการ",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"ความเชี่ยวชาญของผู้ผสานรวม",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"ชื่อบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_BACK ]:"ย้อนกลับ",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"ผลลัพธ์ทั้งหมด",
    [KEYS.L18N_KEY_LABEL_ALL ]:"ทั้งหมด ",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"บันทึกแล้ว",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"บริษัทคู่ค้าของฉัน",
    [KEYS.L18N_KEY_LABEL_ADD ]:"เพิ่ม",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"ลบออก",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"เพิ่มเพื่อเปรียบเทียบ ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"เลือกอย่างน้อยหนึ่งรายการ",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"เปรียบเทียบที่เลือก ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"ลบออกจากตัวเปรียบเทียบ",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"เปรียบเทียบ",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"ระดับของบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"อยู่ระหว่างดำเนินการ",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"ผลลัพธ์",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"ผลลัพธ์",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"ไม่มีผลลัพธ์",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"ผลลัพธ์ใน",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"ผลลัพธ์ใน",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"ไม่มีผลลัพธ์ใน",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"ก่อนหน้า",
    [KEYS.L18N_KEY_LABEL_PREV ]:"ก่อนหน้า",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"หน้าถัดไป",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"บันทึก",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"ทักษะความชำนาญ",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"ภาพรวม",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"คือ Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"ผู้ผสานรวมสร้างโซลูชันจากต้นทางถึงปลายทางสำหรับลูกค้าของเรา พวกเขาทำธุรกรรมเป็นหลักในการขายต่อ แต่นำความเชี่ยวชาญเฉพาะของตนเองมาแก้ปัญหาทางธุรกิจของลูกค้า",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"ผู้ให้บริการเป็นผู้เชี่ยวชาญในการนำเสนอโซลูชันที่มีการจัดการและระบบคลาวด์ ลูกค้ากำลังมองหาความยืดหยุ่นที่มากขึ้นในวิธีที่พวกเขาใช้โซลูชัน และผู้ให้บริการมีความสำคัญมากขึ้นเรื่อยๆ ในตลาด",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"การค้นหาที่ผ่านมา",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"การค้นหาที่ผ่านมา",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"บทบาท ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"เทคโนโลยี",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"อุตสาหกรรม",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"ผู้ผสานรวม",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"ผู้ให้บริการ",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"อื่นๆ",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"อื่นๆ",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"ไม่มีบริษัทคู่ค้ารายอื่นที่บันทึกไว้",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"ไม่มีผู้ผสานรวมที่บันทึกไว้",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"ไม่มีผู้ให้บริการที่บันทึกไว้",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"กรองตามความต้องการ",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"ค้นหาตามเกณฑ์รวม",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"ค้นหาตามตำแหน่ง",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"มีคู่ค้า 1 รายที่ให้บริการทั่วโลก",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"มี",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"บริษัทคู่ค้าที่ให้บริการทั่วโลก",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"ไม่มีบริษัทคู่ค้าที่ให้บริการทั่วโลก",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"มีบริษัทคู่ค้า 1 รายที่ให้บริการใน",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"บริษัทคู่ค้าที่ให้บริการใน",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"ไม่มีบริษัทคู่ค้าที่ให้บริการใน",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"เปลี่ยนสถานที่ตั้ง",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"กรองตามความต้องการ",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"ค้นหา",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"ตามชื่อ ระดับ และความเชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"ที่เลือกไว้",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"ไม่พบรายการที่ตรงกัน",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"อันดับจากด้านบน",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"อันดับจากด้านล่าง",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"ชื่อจากด้านบน",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"ชื่อจากด้านล่าง",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"จำเป็นต้องเข้าสู่ระบบ",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"คุณต้องเข้าสู่ระบบเพื่อดำเนินการนี้",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"การกู้คืนการค้นหาล้มเหลว",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"ล็อกอิน",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"บันทึกบริษัทคู่ค้าเรียบร้อยแล้ว",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"ไม่สามารถบันทึกบริษัทคู่ค้าได้",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"ลบบริษัทคู่ค้าเรียบร้อยแล้ว",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"ไม่สามารถลบบริษัทคู่ค้าได้",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"พิมพ์คำสำคัญเพื่อค้นหาตามชื่อ ระดับ หรือความเชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"นักพัฒนาคือผู้เชี่ยวชาญที่สร้างโซลูชันซอฟต์แวร์และฮาร์ดแวร์ที่ปรับให้เหมาะสมที่สุดบนเทคโนโลยีของ Cisco ซึ่งส่งผลให้เกิดโซลูชันที่ไม่เหมือนใครที่เชื่อมโยงระบบเพื่อส่งมอบผลลัพธ์",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"ที่ปรึกษาคือผู้เชี่ยวชาญที่มีความรู้เชิงลึกในด้านอุตสาหกรรม ซึ่งจะแนะนำธุรกิจต่างๆ ขณะสำรวจโซลูชันเพื่อรับมือกับความท้าทายทางธุรกิจที่ซับซ้อน​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"พันธมิตรที่หลากหลาย",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"ที่เรียงตามลำดับอักษร",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"ความเชี่ยวชาญสูงสุด",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"นักพัฒนา",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"ที่ปรึกษา",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"ตัวกรอง",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"ตัวกรอง",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"ทักษะความชำนาญของคู่ค้า",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"เลิกใช้",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"สาขาที่เชี่ยวชาญ",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"ทักษะความชำนาญ",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"ไม่มีคำอธิบายให้",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"เกี่ยวกับ",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"ล้างตัวเปรียบเทียบ",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"การเปรียบเทียบบริษัทคู่ค้า",
    [KEYS.L18N_KEY_LABEL_ROLE]:"บทบาท",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"โฟกัสด้านเทคโนโลยี",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"คำอธิบาย",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"เลือกการเลือกภาษา",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"ออกจากระบบ",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"บริษัทคู่ค้าที่เป็นหนึ่งเดียวกัน",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "เกี่ยวกับ Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "ติดต่อเรา",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "อาชีพ",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "พบกับพันธมิตรของเรา",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "คำติชม",
    [KEYS.L18N_KEY_LABEL_HELP]: "ช่วย",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "ข้อกำหนดและเงื่อนไข",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "คำชี้แจงสิทธิ์ส่วนบุคคล",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "คุกกี้",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "เครื่องหมายการค้า",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "ความโปร่งใสของห่วงโซ่อุปทาน",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "แผนผังเว็บไซต์",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "เกี่ยวกับ Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "ติดต่อเรา",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "อาชีพ",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "พบกับพันธมิตรของเรา",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "คำติชม",
    [KEYS.L18N_KEY_LABEL_HELP]: "ช่วยเหลือ",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "ข้อกำหนดและเงื่อนไข",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "คำชี้แจงสิทธิ์ส่วนบุคคล",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "คุกกี้",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "เครื่องหมายการค้า",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "ความโปร่งใสของห่วงโซ่อุปทาน",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "แผนผังเว็บไซต์",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "วิธีซื้อ",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "พันธมิตร",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "ผลิตภัณฑ์และบริการ",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "โซลูชัน",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "สนับสนุน",
    [KEYS.L18N_KEY_LABEL_LEARN]: "เรียนรู้",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "สำรวจ Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "เมนู",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "ปิด",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "ดูเพิ่มเติม",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "ดูน้อยลง",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "ไม่มีบัญชีใช่หรือไม่",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "ลงชื่อสมัครใช้"
}
});

export default thTHTranslations;
